import { ReactRouter, useUser } from "@atlassiansox/microscopekit";
import { useMutationUI } from "./useMutationUI";
import { CreateWargameExerciseMutation } from "../graphql";
export var useCreateWargameExercise = function (onCompleted) {
    var history = ReactRouter.useHistory();
    var url = ReactRouter.useRouteMatch().url;
    var user = useUser();
    var _a = useMutationUI({
        mutation: CreateWargameExerciseMutation,
        successMessage: "Wargame exercise created successfully",
        options: {
            onCompleted: function (_a) {
                var id = _a.createWarGameExercise.id;
                onCompleted();
                history.push(url + "/exercise/" + id);
            }
        }
    }), mutate = _a.mutate, isLoading = _a.isLoading;
    return {
        createWargameExercise: function (_a) {
            var _b;
            var name = _a.name, service = _a.service, endDate = _a.endDate;
            var variables = {
                data: {
                    service: service,
                    name: name,
                    createdBy: (_b = user === null || user === void 0 ? void 0 : user.username) !== null && _b !== void 0 ? _b : ""
                }
            };
            if (endDate) {
                variables.data.endDate = endDate;
            }
            return mutate({
                variables: variables
            });
        },
        isCreatingWargameExercise: isLoading
    };
};
